import { Routes } from '@angular/router';
import { MainLayout } from './core/layouts/main-layout/main-layout';
import { authGuard, noAuthGuard } from './features/auth/auth.guard';
import { accessGuard } from './features/auth/access.guard';
import { Login } from './features/auth/login/login';
import { ForgotPassword } from './forgot-password/forgot-password';
import { NoAccess } from './features/auth/no-access';
export const routes: Routes = [
  {
    path: 'login',
    component: Login,
    canActivate: [noAuthGuard],
  },
  {
    path: 'reset-password',
    component: ForgotPassword,
    canActivate: [noAuthGuard],
  },
  {
    path: '',
    component: MainLayout,
    canActivate: [authGuard],
    children: [
            {
              path: 'sin-acceso',
              component: NoAccess,
            },
            {
              path: '',
              loadComponent: () =>
                import('./features/financiador/portal-page/portal-page').then(
                  (m) => m.PortalPage,
                ),
              canActivate: [accessGuard],
              data: { section: 'dashboard', moduleKey: 'dashboard' },
            },
            {
              path: 'clientes/:id',
              loadComponent: () =>
                import('./features/financiador/portal-page/portal-page').then((m) => m.PortalPage),
              canActivate: [accessGuard],
              data: { section: 'clientes', moduleKey: 'clients', clientDetail: true },
            },
            {
              path: 'clientes',
              loadComponent: () =>
                import('./features/financiador/portal-page/portal-page').then(
                  (m) => m.PortalPage,
                ),
              canActivate: [accessGuard],
              data: { section: 'clientes', moduleKey: 'clients' },
            },
            {
              path: 'Conexiones-HPIH',
              loadComponent: () =>
                import('./features/financiador/hpih-connections/hpih-connections-page').then(
                  (m) => m.HpihConnectionsPage,
                ),
              canActivate: [accessGuard],
              data: { section: 'Conexiones-HPIH', moduleKey: 'clients' },
            },
            {
              path: 'oposiciones',
              loadComponent: () =>
                import('./features/financiador/portal-page/portal-page').then(
                  (m) => m.PortalPage,
                ),
              canActivate: [accessGuard],
              data: { section: 'oposiciones', moduleKey: 'oppositions' },
            },
            {
              path: 'notificaciones',
              loadComponent: () => import('./features/notifications/notifications-page/notifications-page').then((m) => m.NotificationsPage),
              data: { section: 'notificaciones' },
            },
            {
              path: 'metricas',
              loadComponent: () =>
                import('./features/financiador/portal-page/portal-page').then(
                  (m) => m.PortalPage,
                ),
              canActivate: [accessGuard],
              data: { section: 'metricas', moduleKey: 'metrics_and_usage' },
            },
            {
              path: 'auditoria',
              loadComponent: () =>
                import('./features/financiador/portal-page/portal-page').then(
                  (m) => m.PortalPage,
                ),
              canActivate: [accessGuard],
              data: { section: 'auditoria', moduleKey: 'audit' },
            },
            {
              path: 'usuarios',
              loadComponent: () =>
                import('./features/financiador/portal-page/portal-page').then(
                  (m) => m.PortalPage,
                ),
              canActivate: [accessGuard],
              data: { section: 'usuarios', moduleKey: 'users_and_roles' },
            },
            {
              path: 'credenciales',
              loadComponent: () =>
                import('./features/financiador/portal-page/portal-page').then(
                  (m) => m.PortalPage,
                ),
              canActivate: [accessGuard],
              data: { section: 'credenciales', moduleKey: 'api_credentials' },
            },
            {
              path: 'perfil/datos-personales',
              loadComponent: () =>
                import('./features/profile/profile-personal-data/profile-personal-data').then(
                  (m) => m.ProfilePersonalData,
                ),
            },
            {
              path: 'perfil/restablecer-clave',
              loadComponent: () =>
                import('./features/profile/reset-pass/reset-pass').then((m) => m.ResetPass),
            },
      { path: '**', redirectTo: '' },
    ],
  },

  {
    path: '**',
    redirectTo: 'login',
  },
];
